import { useState, useEffect } from 'react';

// Retourne `true` si window.google.maps est défini et non null
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const isGmapsLoaded = () => !!(typeof window === 'object' && window.google?.maps);

// Création d'une promise trackant le chargement de gmaps
let loadingPromise: Promise<boolean>;
const loadGoogleMaps = () => {
  loadingPromise ??= new Promise<boolean>(resolve => {
    // Configuration
    const libraries = ['places'];
    const callback = 'onGoogleMapsLoaded';
    // Génération de l'url du script
    const url = new URL('https://maps.googleapis.com/maps/api/js');
    url.searchParams.append('key', process.env.NEXT_PUBLIC_API_KEY_PLACES);
    url.searchParams.append('libraries', libraries.join(','));
    url.searchParams.append('callback', callback);
    // Préparation de la balise script
    const script = document.createElement('script');
    script.src = url.toString();
    script.defer = true;
    // Ajout du listener et chargement
    window[callback] = () => resolve(true);
    document.head.appendChild(script);
  });
  return loadingPromise;
};

/**
 * Ce hook permet de charger le script de Google Maps et de savoir quand il est dispo.
 * Un promise est crée en singleton afin d'éviter de charger la lib plusieurs fois.
 */
export const useGoogleMapsScriptTag = () => {
  const [isGoogleMapsLoaded, setGoogleMapsLoaded] = useState(isGmapsLoaded);
  useEffect(() => void loadGoogleMaps().then(setGoogleMapsLoaded), []);
  return { isGoogleMapsLoaded, loadingPromise };
};
